// extracted by mini-css-extract-plugin
module.exports = {"rtl":"_2VlsX","ltr":"_1zNTb"};